// Jednoduché přepisy textů webu z adminu. t(key, default) vrací přepis nebo default.
export const TX = { map: {} };

export function setTexts(map) {
  TX.map = map || {};
}

export function t(key, fallback) {
  const v = TX.map[key];
  return (v === undefined || v === null || v === "") ? fallback : v;
}
